<template xmlns="http://www.w3.org/1999/html">
    <button v-if="isShowButton" :style="styleButton" class="order_content__buttons_button accept"
            @click.prevent="clickButtonAction" :disabled="isActionProcess">
        <spinner_button
            v-if="isActionProcess"
            :key="'spinner_button_' + itemButton.action"
            :color="colorSpinner"
            :size="'25px'"
        />
        <div v-else class="order_content__buttons_button_text_container">
            <span class="order_content__buttons_button_text"> {{ __t(nameAction) }} </span>
        </div>
    </button>

</template>

<script>
import spinner_button from "../../loader/SpinnerButton.vue";
import spinner from "../../loader/Spinner.vue";
import {colorFunctions} from "../../../mixins/colorFunctions";
import {createHelpers} from "vuex-map-fields";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "action_button",
    props: {
        itemButton: {
            type: Object,
            required: true,
        },
    },
    components: {spinner_button, spinner},
    mixins: [colorFunctions],
    data() {
        return {
            isActionProcess: false,
            colorSpinner: '#FFFFFF',
            timeSelect: null,
        }
    },
    beforeMount() {
        EventBus.$on('change_order_state', this.endAction);
        EventBus.$on('modal_select_time', this.modalSelectTime);
    },
    beforeUnmount() {
        EventBus.$off('change_order_state', this.endAction);
        EventBus.$off('modal_select_time', this.modalSelectTime);
    },
    methods: {
        clickButtonAction() {
            if(this.isActionProcess) {
                return;
            }
            if (this.isTimeButton) {
                EventBus.$emit('click_question_modal', this.itemButton);
                return;
            }
            this.isActionProcess = true;
            this.colorSpinner = this.darkerColorHex(this.itemButton.button_color, 15);
            let params = {
                user: this.user,
                itemButton: this.itemButton,
                timeSelect: this.timeSelect,
                actionName: 'changeOrdersState',
            }
            this.$store.dispatch('orders/CHANGE_ORDER_STATE', params);
        },
        endAction(buttonAction) {
            if (this.itemButton !== buttonAction) {
                return;
            }
            setTimeout(() => {
                this.isActionProcess = false;
                EventBus.$emit('reload_orders_menu_current_order');
            }, 2000);
        },
        clickSelectTime() {

        },
        modalSelectTime(timeSelect) {
            this.timeSelect = timeSelect;
        }
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mOrders([
            'activeItemMenuOrders',
        ]),
        isShowButton() {
            if (this.itemButton.can_make) {
                return this.itemButton.can_make;
            }
            return false;
        },
        nameAction() {
            if (this.itemButton.human) {
                return this.itemButton.human;
            }
            return '';
        },
        styleButton() {
            if (this.itemButton.button_color) {
                return 'background-color:' + this.itemButton.button_color + ';'
            }
            return '';
        },
        styleButtonTime() {
            return 'background-color:' + this.itemButton.button_color + ';'
        },
        isTimeButton() {
            return this.itemButton.has_time_atr;
        }
    },
}
</script>
